module.exports = __webpack_public_path__ + "static/media/mobileBanner.0d43a5fd.png";